import { ReactElement } from 'react';

import { styled } from '../../../../styled';
import type { Theme } from '../../../../theme/interface/detailed';
import { getDateWithTime } from '../../../../utils/getDateWithTime';

type Interface = { date: string; className: string; fromClient: boolean };

const Component = ({ date, className }: Interface): ReactElement => (
	<div className={className}>{getDateWithTime(date)}</div>
);

const MessageTime = styled(Component)(
	({
		theme: {
			chat: {
				messages: {
					messageTime: { colorClient, colorOperator, ...other },
				},
			},
		},
		fromClient,
	}: {
		theme: Theme;
		fromClient: boolean;
	}) => ({
		color: fromClient ? colorClient : colorOperator,
		...other,
	})
);

export { MessageTime };
